import React, {useContext, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation} from "react-router-dom";
import {Menu} from "antd";
import {loadAdminStrategies} from "./adminStrategiesSlice";

const items = [
    {
        label: <Link to='list'>Стратегии</Link>,
        key: 'strategies/list',
    },
    {
        label: <Link to='signals'>Сигналы</Link>,
        key: 'strategies/signals',
    },
]

const StrategiesSider = () => {
    const location = useLocation();

    const dispatch = useDispatch();
    const sorting = useSelector(state => state.adminStrategies.sorting);
    const filters = useSelector(state => state.adminStrategies.filters);
    const pagination = useSelector(state => state.adminStrategies.pagination);
    const tableFilters = useSelector(state => state.adminStrategies.tableFilters);

    const keys = (path) => {
        var segments = path.split('/');
        return segments[2] + '/'+ segments[3];
    }

    useEffect(() => {
        dispatch(loadAdminStrategies(pagination, sorting));
    }, []);

    const strategyFilters = () => {
        if(location.pathname.endsWith('list'))
            return(
                <div>
                    Здесь фильтр<br/>
                    по стратегиям
                </div>
            )
    }

    return(
        <>
            <Menu items={items}
                  selectedKeys={keys(location.pathname)}
            />
            {/*{strategyFilters()}*/}
        </>
    )
}

export default StrategiesSider;
